// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.ce.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	apiConfig: {
		apiUrl: 'https://api.dev.platform.axso.co',
		authPath: 'customer',
		domain: 'api.dev.platform.axso.co',
		basic: {
			key: 'NQzkTt4Gq5REn9vQ4dHetbZEaDueK4wT',
			secret: 'RYnDnP2UarjuwrrFrcRAFmdV3mRCzdqs',
		},
	},
	webclientTripPlannerUrl: '',
	stripe: {
		usd: {
			key: 'pk_test_dlggygYKLP4DjWlqYaJVqS3r00Y6kxmCqr',
		},
		cad: {
			key: 'pk_test_dlggygYKLP4DjWlqYaJVqS3r00Y6kxmCqr',
		},
	},
	mapBox: {
		accessToken: 'pk.eyJ1IjoiZ2JlZ2luIiwiYSI6ImNqdTJqeXdxYjBkOTUzeXBlc2N6aDdseXEifQ.yg3X3KavsDz0sA8wDCtpuw',
		mapUrl: '',
	},
	htmlEditorKey: '',
	facebookAppId: '131870948242639',
	googleClientId: '916187979633-jek02sfiup2jnth8h1r2dqpk8btd9k6k.apps.googleusercontent.com',
	production: false,
	siteUrl: 'https://client-develop.eptix.co',
	siteTitle: 'Eptix',
	version: '2.9.0',
	appLink: 'https://lecircuitelectrique.test-app.link',
	google: {
		apiKey: 'AIzaSyBmbWGbEer4PrGt5BHQZep95S-PxwA0pJ0',
		map: {
			initialPosition: {
				lat: 45.4972159,
				lng: -73.6103642,
			},
		},
		measurementId: null,
		tagManagerId: null,
		reCaptcha: {
			siteKey: '',
		},
	},
	mainNetwork: {
		id: '5cdd70eea2979e7e90c03562',
		name: {
			fr: 'Axso',
			en: 'Axso',
		},
		fullName: {
			fr: 'Axso - Recharge intelligente.',
			en: 'Axso - Smart charging.',
		},
		abbreviation: {
			fr: 'Axso',
			en: 'Axso',
		},
		brand: 'Circuit électrique',
	},
	apple: {
		clientId: 'com.addenergie.circuitelectrique.signin',
		redirectURI: 'https://api.dev.platform.axso.co/v1/customer/signin/apple/redirect',
	},
	defaultCurrency: {
		code: 'CAD',
		digits: 2.0,
		symbol: '$',
	},
	menuItems: [
		{
			path: 'faq',
			labelKey: 'FAQ.NAVIGATION-LABEL',
			submenu: [],
			externalUrl: {
				en: 'https://lecircuitelectrique.com/en/faq',
				fr: 'https://lecircuitelectrique.com/fr/faq',
			},
		},
		{
			path: 'dashboard',
			labelKey: 'DASHBOARD.NAVIGATION-LABEL',
			icon: 'dashboard',
			submenu: [],
		},
		{
			path: 'tripPlanner',
			labelKey: 'TRIP-PLANNER.NAVIGATION-LABEL',
			imageName: 'trip_planner.svg',
			submenu: [],
		},
		{
			path: 'wallet',
			labelKey: 'WALLET.NAVIGATION-LABEL',
			icon: 'account_balance_wallet',
			submenu: [],
		},
		{
			path: '/vehicles',
			labelKey: 'VEHICLE.NAVIGATION-LABEL',
			icon: 'directions_car',
			submenu: [],
		},
		{
			path: 'transactions',
			labelKey: 'TRANSACTION.NAVIGATION-LABEL',
			icon: 'receipt',
			submenu: [],
		},
		{
			path: 'sessions',
			labelKey: 'SESSION.NAVIGATION-LABEL',
			icon: 'update',
			submenu: [],
		},
		{
			path: '/memberCards',
			labelKey: 'MEMBER-CARD.NAVIGATION-LABEL',
			icon: 'credit_card',
			submenu: [],
		},
		{
			path: '/inbox',
			labelKey: 'INBOX.NAVIGATION-LABEL',
			icon: 'inbox',
			submenu: [],
		},
		{
			path: 'settings',
			labelKey: 'SETTING.NAVIGATION-LABEL',
			icon: 'settings',
			submenu: [],
		},
	],
	footerMenuItems: [
		{
			path: 'contact-us',
			labelKey: 'CONTACT-US.NAVIGATION-LABEL',
			submenu: [],
			externalUrl: {
				en: 'https://lecircuitelectrique.com/contact-us',
				fr: 'https://lecircuitelectrique.com/nous-joindre',
			},
		},
		{
			path: 'about',
			labelKey: 'ABOUT.NAVIGATION-LABEL',
			submenu: [],
			externalUrl: {
				en: 'https://lecircuitelectrique.com/about',
				fr: 'https://lecircuitelectrique.com/a-propos',
			},
		},
		{
			path: 'auth/terms-of-use',
			labelKey: 'TERMS-OF-USE.NAVIGATION-LABEL',
			submenu: [],
		},
	],
	firebase: {
		apiKey: 'AIzaSyBmbWGbEer4PrGt5BHQZep95S-PxwA0pJ0',
		authDomain: 'lecircuitelectrique-dev.firebaseapp.com',
		databaseURL: 'https://lecircuitelectrique-dev.firebaseio.com',
		projectId: 'lecircuitelectrique-dev',
		storageBucket: 'lecircuitelectrique-dev.appspot.com',
		messagingSenderId: '356334598493',
		appId: '1:356334598493:web:6e09662cbd5239098dd0b4',
		measurementId: 'G-SQGVKY3YKQ',
	},
	FF_CONFIG_ENABLED: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
